import { pct, perPacked } from '../bamsShortsUtils';

// Side-by-side comparison of this week against the prior week for the same
// facilities and brands.
export function WeekOverWeekPanel({ curRolled, curWeek, priorKey, prvRolled }) {
    return (
        <div className="panel">
            <p className="ptitle">Week over week</p>
            <p className="pnote">
                Week {curWeek} against week {priorKey % 100}, same facilities and brands.
            </p>
            <table>
                <thead>
                    <tr>
                        <th>Facility</th>
                        <th>Brand</th>
                        <th>Prior per packed</th>
                        <th>This week</th>
                        <th>Δ</th>
                        <th>Prior short rate</th>
                        <th>This week</th>
                    </tr>
                </thead>
                <tbody>
                    {curRolled
                        .filter((e) => e.short_ord > 0)
                        .map((e) => {
                            const p = prvRolled.find((x) => x.brand === e.brand && x.facility === e.facility);
                            if (!p) {
                                return (
                                    <tr key={`${e.brand}|${e.facility}`}>
                                        <td>{e.facility}</td>
                                        <td style={{ fontSize: 11, color: 'var(--muted)' }}>
                                            {e.brand.replace('_', ' ')}
                                        </td>
                                        <td colSpan={5} style={{ color: 'var(--muted)' }}>
                                            no prior-week data
                                        </td>
                                    </tr>
                                );
                            }
                            const a = perPacked(p);
                            const b = perPacked(e);
                            const d = a ? ((b - a) / a) * 100 : 0;
                            return (
                                <tr key={`${e.brand}|${e.facility}`}>
                                    <td>{e.facility}</td>
                                    <td style={{ fontSize: 11, color: 'var(--muted)' }}>{e.brand.replace('_', ' ')}</td>
                                    <td style={{ color: 'var(--muted)' }}>{a.toFixed(2)}</td>
                                    <td>{b.toFixed(2)}</td>
                                    <td className={d > 3 ? 'pos' : d < -3 ? 'neg' : ''}>
                                        {d >= 0 ? '+' : ''}
                                        {d.toFixed(0)}%
                                    </td>
                                    <td style={{ color: 'var(--muted)' }}>{pct(p.short_ord, p.packed)}</td>
                                    <td>{pct(e.short_ord, e.packed)}</td>
                                </tr>
                            );
                        })}
                </tbody>
            </table>
        </div>
    );
}
